// SocialsBar.js
import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const Icon = ({ icon, alt = '' }) => {
  if (React.isValidElement(icon)) {
    return <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 20, height: 20 }}>{icon}</span>;
  }
  if (typeof icon === 'string' && icon.length > 0) {
    return <img src={icon} alt={alt} width={20} height={20} style={{ display: 'block' }} />;
  }
  return null;
};

const SocialCard = ({ icon, description, href }) => (
  <Card
    as="a"
    href={href || '#'}
    target="_blank"
    rel="noopener noreferrer"
    className="text-decoration-none border-0 shadow-sm"
    style={{ minWidth: 14 }}
  >
    <Card.Body className="py-2 px-3 d-flex align-items-center">
      <Icon icon={icon} alt={description} />
      {/* <span className="ms-2">{description}</span> */}
    </Card.Body>
  </Card>
);

const SocialsBar = ({ items = [], label = 'contact:' }) => (
  <div>
     <Row xs={12} className="g-2">
        {items.map((it, idx) => (
          <Col key={idx}>
            <SocialCard icon={it.icon} description={it.description} href={it.href} />
          </Col>
        ))}
      </Row>
    </div>
);

export default SocialsBar;
